import { Check, Clock } from '@aktiia/design-system';
import cx from 'classnames';
import { useMemo } from 'react';

import { BpStatusStyle } from '../../../../../constants';
import { BpType } from '../../../../../enums';
import { IBpStatusBadgeProps } from './types';

export const BpStatusBadge = ({ status }: IBpStatusBadgeProps) => {
  const icon = useMemo(() => {
    switch (status) {
      case BpType.PENDING:
        return <Clock className="scale-50" />;
      case BpType.OPTIMAL:
        return <Check className="scale-50" />;
      default:
        return BpStatusStyle[status].badge;
    }
  }, [status]);

  return (
    <span
      className={cx(
        'w-[16px] h-[16px] grid justify-center content-center mr-2 typography-title-5 rounded-full',
        BpStatusStyle[status].badgeBg,
        BpStatusStyle[status].badgeColor,
      )}
    >
      {icon}
    </span>
  );
};
